export const REGISTRATION_NUMBER_MIN = 14;
export const REGISTRATION_NUMBER_MAX = 20;
export const OPFBROADCASTCHANNEL = 'auth-sync';
export const AUTHBROADCASTMESSAGE = 'authDetailUpdate';
export const LOGOUTBROADCASTMESSAGE = 'logout';
